import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import TextInfo, {
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_ALIGN,
  TEXT_KIND,
  TEXT_FONT_WEIGHT,
  TEXT_DISPLAY,
} from '@gc-npm/components.text';
import Button, { BUTTON_TYPE_HTML, BUTTON_WIDTH } from '@gc-npm/components.button';
import CustomLink from '@gc-npm/components.custom-link';
import CheckBox from '@/components/CheckBox';
import IconGlyph from '@gc-npm/components.icon-glyph';
import ICON_ID from '@gc-npm/utils.enums.icon-id';

export const COMPONENT_NAME = 'RetenModalForm';

const RetenModalForm = ({
  formSkeletonProps,
  promoUrlLegal,
  legalText,
  legalLinkText,
  productName,
  submitText,
  dismissText,
  onSubmit,
  componentProduct,
  havePromotion,
  isChecked = false,
}) => {
  const recaptcha = useSelector((state) => state.UI.recaptcha);

  const retenModalFormTaggingInfo = {
    componentName: COMPONENT_NAME,
    componentVariation: `baja_${productName || 'no-recuperado'}`,
    componentContent: productName || '',
    componentProduct: componentProduct || '',
  };

  const [activatePurchaseButton, setActivatePurchaseButton] = useState(isChecked);
  const [checkBoxChecked, setCheckBoxChecked] = useState(isChecked);
  const { validateForm } = { ...formSkeletonProps };

  useEffect(() => {
    if (validateForm && onSubmit && recaptcha) {
      onSubmit(true);
    }
  }, [validateForm]);

  const handleActivatePurchaseButton = (e) => {
    setActivatePurchaseButton(e);
  };

  return (
    <>
      <div className="RetenModalForm">
        <div className="RetenModalForm-legal">
          <CheckBox
            name="legalCheckBox"
            formSkeletonProps={formSkeletonProps}
            taggingInfo={{
              ...retenModalFormTaggingInfo,
            }}
            checked={checkBoxChecked}
            onChange={(e) => {
              handleActivatePurchaseButton(e);
              setCheckBoxChecked(!checkBoxChecked);
            }}
            hidden={!havePromotion}
          >
            {havePromotion && (
              <div className="RetenModalForm-legal_info">
                <TextInfo
                  kind={TEXT_KIND.PARAGRAPH}
                  text={legalText}
                  color={TEXT_COLOR.GREY6}
                  size={TEXT_SIZE.BODY2}
                  align={TEXT_ALIGN.CENTER}
                />
                <CustomLink
                  ariaLabel={legalLinkText}
                  href={promoUrlLegal}
                  taggingInfo={{
                    ...retenModalFormTaggingInfo,
                    componentContent: `${legalLinkText}-${productName || ''}`,
                  }}
                  forceExternal
                  target="_blank"
                >
                  <TextInfo
                    kind={TEXT_KIND.PARAGRAPH}
                    text={legalLinkText}
                    color={TEXT_COLOR.MOVISTAR_BLUE}
                    size={TEXT_SIZE.BODY2}
                    align={TEXT_ALIGN.CENTER}
                  />
                </CustomLink>
              </div>
            )}
          </CheckBox>
        </div>
        <div className="RetenModalForm-button-container">
          {submitText && (
            <Button
              label={submitText}
              buttonTypeHtml={BUTTON_TYPE_HTML.SUBMIT}
              width={BUTTON_WIDTH.MEDIUM}
              disabled={!activatePurchaseButton}
              taggingInfo={{
                ...retenModalFormTaggingInfo,
                componentContent: `${submitText}-${productName || ''}`,
              }}
            />
          )}
          {dismissText && (
            <CustomLink
              className="RetenModalForm-button-container_cancel"
              taggingInfo={{
                ...retenModalFormTaggingInfo,
                componentContent: `${dismissText}-${productName}`,
              }}
              onClick={() => { onSubmit()}}
            >
              <div className="RetenModalForm-button-container_cancel-content">
                <TextInfo
                  text={dismissText}
                  kind={TEXT_KIND.PARAGRAPH}
                  color={TEXT_COLOR.MOVISTAR_BLUE}
                  size={TEXT_SIZE.CAPTION2}
                  align={TEXT_ALIGN.LEFT}
                  fontType={TEXT_FONT_WEIGHT.REGULAR}
                  display={TEXT_DISPLAY.INLINE}
                />
                <IconGlyph
                  id={ICON_ID.CheuronRight}
                  color={TEXT_COLOR.MOVISTAR_BLUE}
                  width={12}
                />
              </div>
            </CustomLink>
          )}
        </div>
      </div>
      <style jsx>
        {`
          .RetenModalForm {
            &-button-container{
              display:flex;     
              gap:1rem;
              &_cancel-content {
                display: flex;
                align-items: center;
                gap: 0.5rem;
              }
            }
            &-legal {
              display: flex;
              align-items: center;
              justify-content: left;
              gap: 0.5rem;
              margin-bottom: 1rem;           

              &_info {
                display: flex;
                gap: 0.2rem;
              }
            }
            @media (max-width: 768px) {
              .RetenModalForm {
                &-button-container {
                  flex-direction: column;
                  gap: 1rem;  
                  :global(.RetenModalForm-button-container_cancel) {
                    margin: 0 auto;
                  }
                }
                &-legal {
                  display: flex;
                  align-items: center;
                  justify-content: left;
                  gap: 0.5rem;
                  margin-bottom: 1rem;           

                  &_info {
                    gap: 0rem;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;
                  }
                }
              }
            }
          }
        `}

      </style>
    </>
  );
};

RetenModalForm.propTypes = {
  legalText: PropTypes.string,
  legalLinkText: PropTypes.string,
};

RetenModalForm.defaultProps = {
  legalText: 'He leído y acepto las ',
  legalLinkText: 'condiciones de la promoción',
};

export default RetenModalForm;
